<svelte:options runes={true} />

<script lang="ts">
  import type { Doc } from '@doc';
  import { localeManager } from '@reactive';
  import { StringId } from '@strings';
  import { APP_ICON_MENU } from '@ui';
  import MenuBar from './MenuBar.svelte';
  import type { MenuConfig } from './menu-types.js';

  let {
    doc = $bindable(),
    selectedGroupClass = $bindable()
  }: {
    doc: Doc;
    selectedGroupClass: string | undefined;
  } = $props();

  function appName() {
    return localeManager.localizedString(StringId.CADET);
  }

  // Define the menu structure for the application
  const menuConfig: MenuConfig[] = [
    {
      label: { icon: APP_ICON_MENU },
      items: [{ label: 'About', value: 'about' }]
    },
    {
      label: { labelId: StringId.FILE_MENU },
      items: [
        { label: 'New', value: 'new' },
        { label: 'Open...', value: 'open' },
        { label: 'Open Recent', value: 'open-recent' },
        { divider: true },
        { label: 'Save', value: 'save' },
        { label: 'Save As...', value: 'save-as' },
        { label: 'Save All', value: 'save-all' },
        { divider: true },
        { label: 'Close', value: 'close' },
        { label: 'Exit', value: 'exit' }
      ]
    },
    {
      label: { labelId: StringId.EDIT_MENU },
      items: [
        { label: 'Undo', value: 'undo' },
        { label: 'Redo', value: 'redo' },
        { divider: true },
        { label: 'Cut', value: 'cut' },
        { label: 'Copy', value: 'copy' },
        { label: 'Paste', value: 'paste' },
        { divider: true },
        { label: 'Select All', value: 'select-all' },
        { label: 'Find', value: 'find' },
        { label: 'Replace', value: 'replace' }
      ]
    },
    {
      label: { labelId: StringId.VIEW_MENU },
      items: [
        { label: 'Zoom In', value: 'zoom-in' },
        { label: 'Zoom Out', value: 'zoom-out' },
        { label: 'Actual Size', value: 'actual-size' },
        { label: 'Fit to Window', value: 'fit-to-window' },
        { divider: true },
        { label: 'Show Grid', value: 'show-grid', type: 'checkbox', checked: true },
        { label: 'Show Rulers', value: 'show-rulers', type: 'checkbox', checked: false },
        { label: 'Show Guides', value: 'show-guides', type: 'checkbox', checked: true },
        { divider: true },
        { label: 'Full Screen', value: 'full-screen' }
      ]
    },
    {
      label: { labelId: StringId.WINDOW_MENU },
      items: [
        { label: 'Minimize', value: 'minimize' },
        { label: 'Maximize', value: 'maximize' },
        { divider: true },
        { label: 'New Window', value: 'new-window' },
        { label: 'Close Window', value: 'close-window' },
        { divider: true },
        { label: 'Bring All to Front', value: 'bring-to-front' }
      ]
    },
    {
      label: { labelId: StringId.HELP_MENU },
      items: [
        { label: 'Documentation', value: 'documentation' },
        { label: 'Keyboard Shortcuts', value: 'shortcuts' },
        { label: 'Report an Issue', value: 'report-issue' }
        // About moved to app menu
      ]
    }
  ];
</script>

<style>
  .top-bar-container {
    display: flex;
    flex-direction: column;
    height: 7rem;
  }

  .h-stack {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }

  .v-stack {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .spacer {
    flex-grow: 1;
  }
</style>

<div id="TopBar" class="top-bar-container">
  <MenuBar menus={menuConfig} />

  <div style="padding: 10px;" class="main-bar h-stack">
    <div style="align-items: center; text-align: center;" class="v-stack">
      <img style="width: 4em;" alt="CADET" src="/CADET.svg" />
      <div style="font-size: 1em; font-weight: var(--sl-font-weight-bold);">
        {appName()}
      </div>
    </div>

    <div class="spacer"></div>
  </div>
</div>
